export enum windowSizes {
  mobileSmall = 375,
  mobileMiddle = 425,
  tablet = 768,
  laptop = 1024,
}
